import { trackerApi } from "../../../core/api/TrackerApi"
import { useMutationCommand, useQueryObject } from "../../../core/components/helpers/queryHelper"
import { ItemLightDto } from "../../../core/items/ItemDataTypes"


export interface CommentaryTrackerDto {
    id: number,
    player1: number,
    player1Items: Array<ItemLightDto>
    player2: string
    player2Items: Array<ItemLightDto>
    always: Array<string>
    sometimes: Array<string>
    paths: Array<string>,
    editKey?: string
}

const getCommentaryTracker = async (id: number) => {

    let commentaryTracker : CommentaryTrackerDto = await trackerApi.callServiceGet("/oot/commentary/" + id)

    return commentaryTracker;
}


export const useQueryCommentaryTracker = (id: number) => {

    let query = useQueryObject<CommentaryTrackerDto>(["commentary-tracker/"+id], () => getCommentaryTracker(id), "", 0, false)

    return query;

}

export interface GenerateCommentaryTracker{
    id: number,
    editKey: string
}

const generateCommentaryTracker = async () => {

    let result: GenerateCommentaryTracker = await trackerApi.callServicePost("/oot/commentary") 
    return result;
}


export const useMutationGenerateCommentaryTracker = () => {

    let mutation = useMutationCommand<void, GenerateCommentaryTracker>(generateCommentaryTracker, "");
    return mutation;
}


const updateCommentaryTracker = async (values: CommentaryTrackerDto) => {

    console.log("call api for update")
    await trackerApi.callServicePost("/oot/commentary/" + values.id, values) 
}


export const useMutationUpdateCommentaryTracker = (id: number) => {

    let mutation = useMutationCommand(updateCommentaryTracker, "", ["commentary-tracker/" + id]);
    
    return mutation;
}